import React from "react";
import FlexibleDatePicker from "../FlexibleDatePicker/FlexibleDatePicker";

export default class BookingCheckAvailabilityModal extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var $header = $(this.refs.header);
    $(window).on("scroll.CheckAvailability", function () {
      $header.css("top", $(window).scrollTop());
    });
  }

  componentWillUnmount() {
    $(window).off("scroll.CheckAvailability");
  }

  render() {
    return (
      <div className="BookingCheckAvailability">
        <div className="BookingCheckAvailabilityModal">
          <div className="CheckAvailabilityHeader" ref="header">
            <h4>{I18n.t("room_availability")}</h4>
            <a
              href="#"
              className="close-button"
              onClick={this.props.onToggleCheckAvailability}
            >
              {I18n.t("close")}
            </a>
          </div>
          <FlexibleDatePicker
            {...this.props}
            onClickDate={this.props.onChangeStartDate}
          />
        </div>
      </div>
    );
  }
}
